import React from 'react';
import AntItem, { FormItemProps as AntFormItemProps } from 'antd/lib/form/FormItem';
import classNames from 'classnames';
import styles from './Form.module.scss';

export interface FormItemProps extends AntFormItemProps {
	marginBottom?: boolean;
}
export const FormItem: React.FC<FormItemProps> = (props: FormItemProps) => {
	//const { marginBottom = true, className, ...props } = props;
	const { className, ...restProps } = props;
	return <AntItem className={classNames(styles.formItem, className)} {...restProps} />;
};

export default FormItem;
